// @flow
import update from 'immutability-helper';

import type { VirtualItem } from '../api';

export const VIRTUAL_SHOPPING_CART_STORAGE_KEY = 'virtualShoppingCart';

const _save = (obj: any) => {
  const str = JSON.stringify(obj);
  localStorage.setItem(VIRTUAL_SHOPPING_CART_STORAGE_KEY, str);
};

export const getVirtualCart = (): VirtualItem[] => {
  let s;
  const raw = localStorage.getItem(VIRTUAL_SHOPPING_CART_STORAGE_KEY);
  if (!!raw) {
    try {
      s = JSON.parse(raw);
    } catch (e) {
      console.error('Error parsing virtual shopping cart');
    }
  }
  return (s: any);
};

export const setVirtualCart = (virtualItem: VirtualItem[]) => _save(virtualItem);

export const addVirtualProduct = (item: VirtualItem) => {
  const cart = getVirtualCart() || [];
  cart.push(item);
  _save(cart);
};

export const editVirtualProduct = (index: number, amount?: number, shipping?: string) => {
  const cart = getVirtualCart() || [];
  const newValues: { [key: string]: any } = {};
  if (typeof amount === 'number' && !!amount) {
    newValues.amount = { $set: amount };
  }
  if (typeof shipping === 'string' && !!shipping) {
    newValues.shipping = { $set: shipping };
  }
  const newCart = update(cart, {
    [index]: { ...newValues },
  });
  _save(newCart);
};

export const removeVirtualProduct = (index: number) => {
  const cart = getVirtualCart() || [];
  const newCart = update(cart, {
    $splice: [[index, 1]],
  });
  _save(newCart);
};

export const removeVirtualCart = () => localStorage.removeItem(VIRTUAL_SHOPPING_CART_STORAGE_KEY);



// WEBPACK FOOTER //
// ./src/modules/shopping-cart/utils/virtual-cart-storage.js